import { combineReducers } from 'redux';

import { reducer as businessesReducer } from './businesses';
import { reducer as customersReducer } from './customers';

export default combineReducers({
  businesses: businessesReducer,
  customers: customersReducer,
});
